module.exports = __webpack_public_path__ + "img/creating-event-loader-2.7abb5636.gif";